import useSWR from 'swr';
import { v4 as uuid4 } from 'uuid';

export const useStudioAnalytics = () => {
  useSWR(
    ['graph', 'analytics'],
    async () => {
      const ID_LS_KEY = 'ls:studio:analytics:instance';
      let instanceId = window.localStorage.getItem(ID_LS_KEY);
      if (!instanceId) instanceId = uuid4();
      window.localStorage.setItem(ID_LS_KEY, instanceId);

      const supabaseUrl = import.meta.env.VITE_STUDIO_ANALYTICS_SUPABASE_URL;
      const supabaseKey = import.meta.env.VITE_STUDIO_ANALYTICS_SUPABASE_KEY;

      if (!supabaseUrl || !supabaseKey) return;
      await fetch(`${supabaseUrl}/rest/v1/web_logs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: supabaseKey,
          'User-Agent': 'Mozilla/5.0',
        },
        body: JSON.stringify({
          action: 'mount',
          params: { instanceId },
        }),
      });
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }
  );
};
